import AccessoriesSidebar from "components/shopFeatures/accessories/AccessoriesSidebar"
import ColorSidebar from "components/shopFeatures/color/ColorSidebar"
import DetailingSidebar from "components/shopFeatures/detailing/DetailingSidebar"
import OrderPage from "components/shopFeatures/order/OrderPage"
import PaymentPage from "components/shopFeatures/payment/PaymentPage"
import UpholsterySidebar from "components/shopFeatures/upholstery/UpholsterySidebar"
import React, { useRef } from "react"
import { Route, useLocation } from "react-router-dom"
import { CSSTransition } from "react-transition-group"
import routes from "routes"
import styled from "styled-components"
import SummaryPage from "../summary/SummaryPage"
import { SIDEBAR_WIDTH, STEPS_EN } from "./constants"
import Steps from "./stepsNav/Steps"

const routesToComponents: { [path: string]: React.ComponentType } = {
  [routes.detailing.path]: DetailingSidebar,
  [routes.color.path]: ColorSidebar,
  [routes.upholstery.path]: UpholsterySidebar,
  [routes.accessories.path]: AccessoriesSidebar,
  [routes.summary.path]: SummaryPage,
  [routes.order.path]: OrderPage,
  [routes.payment.path]: PaymentPage,
}

const StyledSideContent = styled.div<{ $page: string }>`
  ${(p) => p.theme.breakpoints.up("md")} {
    background-color: ${(p) => p.theme.colors.lightGrey};
    width: ${(p) =>
      p.$page === STEPS_EN.summary
        ? `calc(100% - ${SIDEBAR_WIDTH}px)`
        : `${SIDEBAR_WIDTH}px`};
    flex-shrink: 0;
    padding: 0;
    // ${(p) => p.$page !== STEPS_EN.summary && "overflow: hidden;"}
    position: relative;

    border-left: 1px solid ${(p) => p.theme.colors.borderGrey};
    transition: width 0.5s ease;
  }
`
const StyledTransitionWrapper = styled.div<{ $page?: string }>`
  // height: 100%;
  position: absolute;
  inset: 0;
  inset-block-start: ${(p) =>
    p?.$page !== STEPS_EN.order && p?.$page !== STEPS_EN.payment && "50px"};

  &.fade-enter {
    opacity: 0;
    transform: translateY(50px);
    z-index: 1;
  }

  &.fade-enter-active {
    opacity: 1;
    transform: translateY(0);
    transition: transform ease 300ms, opacity ease 300ms;
  }

  &.fade-exit {
    opacity: 1;
    transform: translateY(0);
  }

  &.fade-exit-active {
    opacity: 0;
    transition: transform ease 300ms, opacity ease 300ms;
    z-index: 1;
  }
`

const ComponentContainer = styled.div<{ $page?: string }>`
  padding: ${(p) => {
    if (p?.$page === STEPS_EN.summary) return "55px 30px"
    return "0 30px 30px 30px"
  }};

  direction: ltr;
  > * {
    direction: rtl;
  }
  overflow: auto;
  height: 100%;
`

const Sidebar = () => {
  const { pathname } = useLocation()
  const nodeRefs = useRef<{ [key: string]: React.RefObject<HTMLDivElement> }>(
    {}
  )

  // Create refs for each route
  routes.array.forEach((route) => {
    if (!nodeRefs.current[route.path]) {
      nodeRefs.current[route.path] = React.createRef<HTMLDivElement>()
    }
  })

  return (
    <>
      <StyledSideContent $page={pathname}>
        {pathname !== STEPS_EN.order && pathname !== STEPS_EN.payment && (
          <Steps />
        )}
        {routes.array.map((route) => {
          return (
            <Route key={route.path} path={route.path}>
              {({ match }) => {
                const Component = routesToComponents[route.path]
                return (
                  <CSSTransition
                    nodeRef={nodeRefs.current[route.path]}
                    in={match != null}
                    timeout={300}
                    classNames="fade"
                    unmountOnExit
                  >
                    <StyledTransitionWrapper
                      ref={nodeRefs.current[route.path]}
                      $page={pathname}
                      id="transitionwrapper"
                    >
                      <ComponentContainer $page={pathname}>
                        <Component />
                      </ComponentContainer>
                    </StyledTransitionWrapper>
                  </CSSTransition>
                )
              }}
            </Route>
          )
        })}
      </StyledSideContent>
    </>
  )
}

export default Sidebar
